<template>
  <div ref="layout" class="app-layout">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppLayout',
}
</script>

<style lang="scss" scoped>
@import '@/styles/settings.scss';
@import '@/styles/functions.scss';

.app-layout {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 100%;
  max-width: 100vw;
  position: relative;

  // &:first-of-type {
  //   min-height: 100vh;
  // }

  // .app-layout {
  //   overflow-y: unset;
  //   min-height: 0;
  // }

  // &.header-negative-radius {
  //   :deep(.app-layout-header) {
  //     border-bottom-left-radius: 0;
  //     border-bottom-right-radius: 0;
  //   }

  //   :deep(.app-layout-content) {
  //     &::before {
  //       content: '';
  //       position: absolute;
  //       height: 50%;
  //       top: 0;
  //       left: 0;
  //       right: 0;
  //       z-index: -1;
  //       background-color: var(--primary-color);
  //     }

  //     > .content {
  //       border-top-left-radius: 25px;
  //       border-top-right-radius: 25px;
  //     }
  //   }
  // }

  // &.footer-negative-radius {
  //   :deep(.app-layout-footer) {
  //     border-top-left-radius: 0;
  //     border-top-right-radius: 0;
  //   }

  //   :deep(.app-layout-content) {
  //     &::after {
  //       content: '';
  //       position: absolute;
  //       height: 50%;
  //       bottom: 0;
  //       left: 0;
  //       right: 0;
  //       z-index: -1;
  //       background-color: var(--primary-color);
  //     }

  //     > .content {
  //       border-bottom-left-radius: 25px;
  //       border-bottom-right-radius: 25px;
  //     }
  //   }
  // }

  :deep(.app-flex) {
    display: flex;

    &.align-center {
      align-items: center;
    }

    &.justify-center {
      justify-content: center;
    }

    &.wrap {
      flex-wrap: wrap;
    }
  }

  :deep(h1),
  :deep(h2),
  :deep(h3),
  :deep(h4),
  :deep(h5),
  :deep(h6) {
    margin-top: 0;
    margin-bottom: 1rem;
    // line-height: 100%;

    &:last-child {
      margin-bottom: 0;
    }
  }

  // :deep(a) {
  //   &:not(.md-button) {
  //     color: initial;
  //   }
  // }

  :deep(.text-bold) {
    font-weight: bold;
  }

  :deep(.text-muted) {
    opacity: 0.54;
  }

  :deep(.text-center) {
    text-align: center;
  }

  :deep(.text-uppercase) {
    text-transform: uppercase;
  }

  :deep(.regular-font) {
    font-weight: normal;
  }

  :deep(.app-container) {
    padding: $defaultPadding;
  }

  :deep(.app-side-container) {
    padding-left: $defaultPadding;
    padding-right: $defaultPadding;
  }

  :deep(.inline-block) {
    display: inline-block;
  }

  :deep(.horizontal-flow) {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    overflow-x: auto;
    scroll-behavior: smooth;
  }

  :deep(.block) {
    display: block;
  }

  :deep(.negative-margin) {
    margin-left: -#{$defaultPadding};
    margin-right: -#{$defaultPadding};
  }

  :deep(.flex) {
    display: flex;

    &:not(.column) {
      &.align-items-center,
      &.vertical-center {
        align-items: center;
      }

      &.justify-content-center,
      &.horizontal-center {
        justify-content: center;
      }
    }

    &.column {
      flex-direction: column;

      &.align-items-center,
      &.vertical-center {
        justify-content: center;
      }

      &.justify-content-center,
      &.horizontal-center {
        align-items: center;
      }
    }

    &.center {
      align-items: center;
      justify-content: center;
    }
  }
}

:deep([class^='line-clamp-']),
:deep([class*=' line-clamp-']) {
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}

:deep(.line-clamp-1) {
  -webkit-line-clamp: 1;
}

:deep(.line-clamp-2) {
  -webkit-line-clamp: 2;
}

:deep(.line-clamp-3) {
  -webkit-line-clamp: 3;
}
</style>
